"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SnackbarContent = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CheckCircle = _interopRequireDefault(require("@mui/icons-material/CheckCircle"));
var _Error = _interopRequireDefault(require("@mui/icons-material/Error"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _Warning = _interopRequireDefault(require("@mui/icons-material/Warning"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _Snackbar = _interopRequireDefault(require("@mui/material/Snackbar"));
var _SnackbarContent = _interopRequireDefault(require("@mui/material/SnackbarContent"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _mui = require("tss-react/mui");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["title", "message", "onClose", "action", "type", "className"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Snackbar = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    message = _ref.message,
    title = _ref.title,
    action = _ref.action,
    type = _ref.type;
  var handleClose = function handleClose(event, reason) {
    if (reason === 'clickaway') return;
    onClose(event);
  };
  return /*#__PURE__*/_react["default"].createElement(_Snackbar["default"], {
    ref: ref,
    open: open,
    onClose: handleClose,
    autoHideDuration: 6000
  }, /*#__PURE__*/_react["default"].createElement(SnackbarContent, {
    onClose: handleClose,
    title: title,
    message: message,
    action: action,
    type: type
  }));
});
Snackbar.propTypes = {
  onClose: _propTypes["default"].func.isRequired,
  open: _propTypes["default"].bool.isRequired,
  title: _propTypes["default"].string,
  message: _propTypes["default"].string,
  action: _propTypes["default"].shape({
    text: _propTypes["default"].string,
    onClick: _propTypes["default"].func
  }),
  type: _propTypes["default"].oneOf(['error', 'success', 'warning'])
};
Snackbar.defaultProps = {
  title: undefined,
  message: undefined,
  action: null,
  type: undefined
};
var _default = Snackbar;
exports["default"] = _default;
var variantIcon = {
  success: _CheckCircle["default"],
  warning: _Warning["default"],
  error: _Error["default"]
};
var useWrapperStyles = (0, _mui.makeStyles)()(function (theme, _params, classes) {
  return {
    root: {
      boxShadow: 'none',
      borderRadius: 8,
      padding: theme.spacing(1)
    },
    success: _defineProperty({
      color: theme.palette.green.dark,
      backgroundColor: theme.palette.green.light
    }, "& .".concat(classes.icon), {
      color: theme.palette.green.main
    }),
    error: _defineProperty({
      color: theme.palette.red.dark,
      backgroundColor: theme.palette.red.light
    }, "& .".concat(classes.icon), {
      color: theme.palette.red.main
    }),
    warning: _defineProperty({
      color: theme.palette.yellow.dark,
      backgroundColor: theme.palette.yellow.light
    }, "& .".concat(classes.icon), {
      color: theme.palette.yellow.main
    }),
    action: {
      margin: 0,
      padding: 0
    },
    closeButton: {
      padding: 0
    },
    icon: {
      margin: theme.spacing(0, 2, 0, 1)
    },
    messageContainer: {
      padding: 0,
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      wordBreak: 'break-word'
    },
    title: {
      fontWeight: 'bold',
      margin: 0
    },
    message: {
      margin: 0
    },
    bold: {
      fontWeight: 'bold'
    }
  };
});
var SnackbarContent = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var title = _ref2.title,
    message = _ref2.message,
    onClose = _ref2.onClose,
    action = _ref2.action,
    type = _ref2.type,
    className = _ref2.className,
    other = _objectWithoutProperties(_ref2, _excluded);
  var _useWrapperStyles = useWrapperStyles(),
    classes = _useWrapperStyles.classes,
    cx = _useWrapperStyles.cx;
  var Icon = variantIcon[type];
  return /*#__PURE__*/_react["default"].createElement(_SnackbarContent["default"], _extends({
    ref: ref,
    className: cx(classes.root, classes[type], className),
    classes: {
      message: classes.messageContainer,
      action: classes.action
    },
    message: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Icon, {
      className: classes.icon
    }), /*#__PURE__*/_react["default"].createElement("div", null, title && /*#__PURE__*/_react["default"].createElement("h4", {
      className: classes.title
    }, title), /*#__PURE__*/_react["default"].createElement("p", {
      className: cx(classes.message, !title && classes.bold)
    }, message))),
    action: action ? /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      key: "undo",
      color: "inherit",
      size: "small",
      onClick: action.onClick
    }, action.text) : /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      key: "close",
      "aria-label": "close",
      color: "inherit",
      onClick: onClose,
      className: classes.closeButton
    }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null))
  }, other));
});
exports.SnackbarContent = SnackbarContent;
SnackbarContent.propTypes = {
  title: _propTypes["default"].string,
  message: _propTypes["default"].string,
  onClose: _propTypes["default"].func,
  action: _propTypes["default"].shape({
    text: _propTypes["default"].string,
    onClick: _propTypes["default"].func
  }),
  type: _propTypes["default"].oneOf(['error', 'success', 'warning']),
  className: _propTypes["default"].string
};
SnackbarContent.defaultProps = {
  title: undefined,
  onClose: undefined,
  message: '',
  action: null,
  type: 'success',
  className: undefined
};